module.exports = __webpack_public_path__ + "img/szjc15.dcbaa082.png";